import React from 'react'
import PropTypes from 'prop-types'
import { Editor } from '@tinymce/tinymce-react'
import { CircularProgress, Divider, Grid, TextField, Typography, useTheme } from '@material-ui/core'
import Autocomplete from '@material-ui/lab/Autocomplete'

import { cutMaxLength } from 'utils/helpers'
import { useStyles } from './FormConclusao.styles'
import { useFormConclusao } from './useFormConclusao'

const maxLength250 = (newValue) => cutMaxLength(newValue, 250)

export const FormConclusao = (props) => {
  const { exameNecroscopico, form } = props
  const classes = useStyles()
  const theme = useTheme()
  const isDark = theme.palette.type === 'dark'

  const {
    tiposExames,
    processandoTiposExames,
    editorRef,
    options,
    initialValue,
    handleConclusaoChange,
  } = useFormConclusao({
    exameNecroscopico,
    form,
  })

  return (
    <div>
      {processandoTiposExames ? (
        <div className={classes.carregando}>
          <CircularProgress disableShrink />
        </div>
      ) : (
        <Grid alignItems="center" container justifyContent="space-between">
          <Grid item md={12} sm={12} xs={12} className={classes.field}>
            <Autocomplete
              name="exSubs"
              value={form.formState.values.exSubs || []}
              noOptionsText="Sem informações"
              multiple
              getOptionSelected={(option, value) => option.id === value.id}
              options={tiposExames || []}
              onChange={(event, newValue) => form.handleChangeNewValueByNameProperty(event, newValue, 'exSubs')}
              getOptionLabel={(option) => option.nome}
              renderOption={(option) => option.nome}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  label="Exames subsidiários"
                  InputLabelProps={{
                    shrink: true,
                    className: classes.labelInput,
                  }}
                />
              )}
            />
          </Grid>

          <Grid item md={12} sm={12} xs={12} className={classes.field}>
            <Autocomplete
              name="causaMorte"
              value={form.formState.values.causaMorte || null}
              noOptionsText="Sem informações"
              getOptionSelected={(option, value) => option.id === value.id}
              options={options.causasMorte || []}
              onChange={(event, newValue) => form.handleChangeNewValueByNameProperty(event, newValue, 'causaMorte')}
              getOptionLabel={(option) => option.nome}
              renderOption={(option) => option.nome}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  label="Causa da morte"
                  InputLabelProps={{
                    shrink: true,
                    className: classes.labelInput,
                  }}
                />
              )}
            />
          </Grid>
          
          <Grid item sm={12} xs={12} lg={12} md={12} className={classes.field}>
            <TextField
              value={form.formState.values.causaMorteTextoLivre || ''}
              name="causaMorteTextoLivre"
              variant="outlined"
              label="OUTRA CAUSA DA MORTE"
              fullWidth
              onChange={(e) => form.handleChangeWithModification(e, maxLength250)}
              disabled={form.formState.values.causaMorte?.nome?.toUpperCase() !== 'OUTRO'}
              InputLabelProps={{
                shrink: true,
              }}
            />
            <Typography variant="caption">
              Caracteres restantes: {250 - (form.formState.values.causaMorteTextoLivre?.length || 0)}
            </Typography>
          </Grid>

          <Grid item md={12} sm={12} xs={12} className={classes.campoConclusao}>
            <Typography className={classes.tituloConclusao} variant="h5">
              Discussão e conclusão
            </Typography>
            <Divider className={classes.divider} />
            <Grid item md={12} sm={12} xs={12} className={classes.item}>
              <Editor
                key={isDark ? 'dark-editor' : 'light-editor'}
                tinymceScriptSrc="/tinymce/tinymce.min.js"
                licenseKey="gpl"
                // eslint-disable-next-line no-return-assign
                onInit={(_, editor) => (editorRef.current = editor)}
                initialValue={initialValue}
                onChange={handleConclusaoChange}
                init={{
                  style_formats: [
                    {
                      title: 'Indent',
                      selector: 'p',
                      styles: { 'text-indent': '30px' },
                    },
                  ],
                  style_formats_merge: true,
                  relative_urls: false,
                  remove_script_host: false,
                  convert_urls: true,
                  pagebreak_separator: '<p style="page-break-after: always;">&nbsp;</p>',
                  menubar: false,
                  plugins: ['advlist autolink lists link image charmap print preview anchor', 'searchreplace visualblocks code fullscreen', 'insertdatetime media table paste code help wordcount pagebreak'],
                  toolbar: 'undo redo | formatselect | table | ' + 'bold italic backcolor | alignleft aligncenter ' + 'alignright alignjustify | bullist numlist | ' + 'removeformat | help | pagebreak',
                  skin: isDark ? 'oxide-dark' : 'oxide',
                  content_css: isDark ? 'dark' : 'default',
                  content_style: isDark
                    ? 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px; background-color: #282C34; color: #fff; }'
                    : 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px; background-color: #fff; color: #000; }',
                }}
              />
            </Grid>
          </Grid>
        </Grid>
      )}
    </div>
  )
}

FormConclusao.propTypes = {
  exameNecroscopico: PropTypes.object.isRequired,
  form: PropTypes.object.isRequired,
}
